var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.388 21.575l-8.984-9.599 8.643-9.895a.95.95 0 00-.08-1.333.917.917 0 00-1.314.082l-8.546 9.763-8.87-9.466a.915.915 0 00-1.314-.033.95.95 0 00-.032 1.333l8.983 9.599-8.66 9.894a.95.95 0 00.082 1.334c.178.165.405.23.616.23.26 0 .52-.115.697-.312l8.546-9.78 8.87 9.483a.902.902 0 00.682.297.94.94 0 00.648-.264.981.981 0 00.033-1.333z",
    fill: "#878789"
  })));
}

export default SvgClose;